var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChatMessages({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.667969 2.5C0.667969 1.39543 1.5634 0.5 2.66797 0.5H9.66797C10.7725 0.5 11.668 1.39543 11.668 2.5V6.5C11.668 7.60457 10.7725 8.5 9.66797 8.5H7.66797L4.66797 11.5V8.5H2.66797C1.5634 8.5 0.667969 7.60457 0.667969 6.5V2.5Z",
    fill: "#888DA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.668 4.5V6.5C13.668 8.70914 11.8771 10.5 9.66797 10.5H8.49639L6.72969 12.2667C7.00951 12.4156 7.32888 12.5 7.66797 12.5H9.66797L12.668 15.5V12.5H14.668C15.7725 12.5 16.668 11.6046 16.668 10.5V6.5C16.668 5.39543 15.7725 4.5 14.668 4.5H13.668Z",
    fill: "#888DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatMessages);
export default __webpack_public_path__ + "static/media/icon-chat-messages.db94fb902b3c46b7e7a1260a3d808342.svg";
export { ForwardRef as ReactComponent };